import { IconButton } from "@circleco/compass/components/IconButton";
import { Select } from "@circleco/compass/components/Select";

import { t } from "@/i18n-js/instance";
import { useIsUnifiedInboxRoute } from "@/react/hooks/chatsV2/messaging/useIsUnifiedInboxRoute";
import type {
  ChatSortType,
  ChatType,
} from "@/react/types/CommunityBot/ChatSort";

interface DropdownMenuComponentProps<T extends ChatSortType | ChatType> {
  activeItem: T;
  align?: "start" | "center" | "end";
  dataTestId?: string;
  items: T[];
  localeScope: string;
  onItemClick: (item: T) => void;
}

export const DropdownMenuComponent = <T extends ChatSortType | ChatType>({
  activeItem,
  align = "start",
  dataTestId,
  items,
  localeScope,
  onItemClick,
}: DropdownMenuComponentProps<T>) => {
  const isUnifiedInboxRoute = useIsUnifiedInboxRoute();
  const options = items.map(item => ({
    value: item,
    label: t([localeScope, item]),
  }));

  const selectedOption = options.find(opt => opt.value === activeItem) ?? null;

  return (
    <Select<T>
      options={options}
      value={selectedOption}
      align={align}
      side="bottom"
      trigger={
        <IconButton
          type="button"
          icon="arrow-bottom-top"
          variant={isUnifiedInboxRoute ? "outline" : "ghost"}
          size={isUnifiedInboxRoute ? "md" : "sm"}
          data-testid={dataTestId}
          aria-label={t("community_inbox.header.sort")}
        />
      }
      onValueChange={opt => {
        if (opt) onItemClick(opt.value);
      }}
    />
  );
};
